// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2NN20","question":"Question_question__1XLFF","description":"Question_description__2lljZ"};